import {ProductInListElementType, ProductInListMapType, ProductInSearchParamType} from "../interface";

export const productInSearchParamInit: ProductInSearchParamType = {
    keyword: "",
    keywordType: "1",
    // 내부수정: 키워드 초기화
    keyword1: "",
    keywordType1: "1",
    keyword2: "",
    keywordType2: "1",
    limit: 10,
    pageNo: 1,
    statusCodeList: ["N"] // ["Y", "N"]
}

export const productInListMapInit: ProductInListMapType = {
    totalCount: 0,
    productList: []
}

export const productInListElementInit: ProductInListElementType = {
    newErpProductid: "",
    vendor: "",
    category: "",
    new_txt_nm_item: "",
    new_txt_stnd_item: "",
    majorCategory: "",
    subCategory: "",
    currency: "",
    levelA: "",
    levelB: "",
    levelC: "",
    levelD: "",
    levelE: "",
    productRange: ""
}